import { AccessLevels } from '../../config/access.levels';
import React, { CSSProperties, useCallback, useEffect } from 'react';
import { useThunkDispatch, useTypedSelector } from 'hooks';
import { Styles } from '../Tools';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import { useFormik } from 'formik';
import * as yup from 'yup';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';

import Select from '@material-ui/core/Select';
import { NewUser } from '../../types/api/responses';
import Button from '@material-ui/core/Button';
import {
  resetUser,
  userOffices,
  resetPasswordUser,
  userProcess,
  deviceTest,
} from 'redux/actions/users.actions';
import { newDevice, resetNewDevice } from 'redux/actions/devices.actions';
import { RolesList } from '../Tools';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { FilterZoneOffice } from '../ListWorshop/FilterZoneOffice';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import { NameRole } from './ListUser';
import { LinkOff, Save, VpnKey } from '@material-ui/icons';

export type NewUserParams = {
  isNew: boolean;
  user: NewUser;
  handleClose: (loading: boolean | null, error?: boolean) => void;
};

const validationSchema = yup.object({
  name: yup
    .string()
    .trim()
    .min(3, 'El nombre debe tener mínimo 3 caracteres')
    .max(150, 'El nombre debe tener máximo 150 caracteres')
    .required('El nombre es requerido'),
  lastName: yup
    .string()
    .trim()
    .min(3, 'El apellido debe tener mínimo 3 caracteres')
    .max(150, 'El apellido debe tener máximo 150 caracteres')
    .required('El apellido es requerido'),
  imei: yup
    .string()
    .min(16, 'El IMEI debe tener 16 caracteres')
    .max(16, 'El IMEI debe tener 16 caracteres')
    .matches(/[0-9]{16}/, 'El IMEI debe contener solo números'),
  number: yup
    .string()
    .trim()
    .min(8, 'El número debe contener 8 caracteres')
    .max(8, 'El número debe contener 8 caracteres')
    .matches(/[0-9]{8}/, 'Solo se permiten números'),
  manufacture: yup.string().trim().max(35, 'Máximo 35 caracteres'),
  model: yup.string().trim().max(100, 'Máximo 100 caracteres'),
});

// Función para mapear accessLevel a roleId
const getRoleIdFromAccessLevel = (accessLevel: number): string => {
  const role = RolesList.find((r) => r.level === accessLevel);
  return role ? role.id : 'Admin'; // Fallback a Admin
};

// Función para mapear roleId a accessLevel
const getRoleLevelFromId = (roleId: string): number => {
  const role = RolesList.find((r) => r.id === roleId);
  return role ? role.level : 1; // Fallback a Collector
};

export function NewUsers(params: NewUserParams) {
  const classes = Styles();
  const dispatch = useThunkDispatch();
  const users = useTypedSelector((z) => z.users);
  const devices = useTypedSelector((z) => z.devices);
  //verificar rol de usuario actual
  const myRole = useTypedSelector((z) => z.session).user.role.accessLevel;
  //control de open/close de selec rol
  const [openRol, setOpenRol] = React.useState(false);
  //comprobar si el usuario tiene o no dispositivo
  const [isDevice, setIsDevice] = React.useState<boolean | null>(null); //si tiene dispositivo

  const [isDeviceNew, setIsDeviceNew] = React.useState(false); //si el dispsitivo sera nuevo o no
  //mensaje personalizado para la sucursal
  const [errorMessage, setErrorMessage] = React.useState('');

  //rol a asignar al usuuario que se creara (como id string)
  const [rol, setRol] = React.useState(params.user.roleId || getRoleIdFromAccessLevel(params.user.accessLevel));

  const validateRoleRequiredDevice = (roleId: string) => {

    if(roleId == 'FinanceManager') return false;

    const roleLevel = getRoleLevelFromId(roleId);
    const access = [
      AccessLevels.ZoneManager,
      AccessLevels.Census,
      AccessLevels.RegionManager,
      AccessLevels.StoreManager,
      AccessLevels.Collector,
    ];

    return access.includes(roleLevel);
  };

  //variable para ver si el usuario se le asigna un dispositivo
  const [isAsigned, setIsAsigned] = React.useState(
    validateRoleRequiredDevice(params.user.roleId || getRoleIdFromAccessLevel(params.user.accessLevel)),
  ); //quiero asignar o no dispositivo

  //sirve para ver si al usuario se le asignara o no sucursal (visualmente ya que siempre se le asigna)
  const [zoneManager, setZoneManger] = React.useState<number | undefined>(
    params.user.accessLevel,
  );
  //variablke que guarda el id de la sucursal seleccionada
  const [office, setOffice] = React.useState(
    params.user.branchOfficeId
      ? params.user.branchOfficeId
      : params.user.accessLevel >= AccessLevels.RegionManager &&
        users.branchOffices.offices.length > 0
      ? users.branchOffices.offices[0].id
      : '0',
  );
  //variable que guarda la zona seleccionada
  const [theZone] = React.useState(
    params.user.zoneId
      ? params.user.zoneId
      : params.user.accessLevel >= AccessLevels.RegionManager &&
        users.branchOffices.offices.length > 0
      ? users.branchOffices.offices[0].zone.id
      : 0,
  );
  //bandera para cargar zonas y sucursales al entrar a la creacion edicion de usuario
  const [init, setInit] = React.useState(true);
  //variable que guarda la contraseña a asignar
  const [passwordKey, setPasswordKey] = React.useState('');
  const [messageErrorImei, setMessageErrorImei] = React.useState('');
  const [attemptedSubmit, setAttemptedSubmit] = React.useState(false);
  const isExistingUser = !params.isNew;

  const formik = useFormik({
    initialValues: {
      name: params.user.name,
      lastName: params.user.lastName,
      imei: '',
      manufacture: '',
      model: '',
      number: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setAttemptedSubmit(true);
      
      // Validar sucursal
      if (office === '0' && getRoleLevelFromId(rol) < AccessLevels.ZoneManager) {
        return;
      }
      
      // Validar dispositivo para roles que lo requieren
      if (rol !== 'FinanceManager' && getRoleLevelFromId(rol) <= AccessLevels.RegionManager && (!values.imei || values.imei.trim() === '')) {
        setMessageErrorImei('Debe asignar un dispositivo para este rol');
        return;
      }
      
      setMessageErrorImei('');
      setErrorMessage('');
      
      if (isAsigned) {
        if (values.imei.trim() == '') {
          setMessageErrorImei('Ingrese Imei');
          return;
        }
        
        if (isDeviceNew) {
          dispatch(
            newDevice(
              {
                imei: values.imei,
                manufacture: values.manufacture ? values.manufacture.trim() : null,
                model: values.model ? values.model.trim() : null,
                enable: true,
                number: values.number ? values.number.trim() : null,
                assigned: null,
              },
              handleSaveUser,
            ),
          );
        } else {
          dispatch(
            deviceTest(
              {
                name: values.name.trim(),
                lastName: values.lastName.trim(),
                role: rol,
                branchOfficeId: office !== '0' ? office : users.branchOffices.offices[0].id,
                deviceImei: values.imei ? values.imei : null,
              },
              params.isNew ? undefined : params.user.userName,
              () => {
                setErrorMessage('El Imei ingresado no esta registrado');
              },
            ),
          );
        }
      } else {
        handleSaveUser();
      }
    },
  });

  const clearDeviceExtraFields = useCallback(() => {
    formik.setFieldValue('manufacture', '', false);
    formik.setFieldValue('model', '', false);
    formik.setFieldValue('number', '', false);
  }, [formik]);

  const resetDeviceFields = useCallback(() => {
    formik.setFieldValue('imei', '', false);
    clearDeviceExtraFields();
  }, [clearDeviceExtraFields, formik]);

  const handleFormikChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      formik.handleChange(event);
      setMessageErrorImei('');
      setErrorMessage('');
    },
    [formik],
  );

  useEffect(() => {
    if (params.isNew) {
      return; // No cargar dispositivo si es nuevo usuario
    }

    if (users.isLoading) {
      return;
    }

    const deviceImei = users.userDevice?.device.imei;

    if (deviceImei) {
      if (!isDevice) {
        setIsDevice(true);
      }
      if (formik.values.imei !== deviceImei) {
        formik.setFieldValue('imei', deviceImei, false);
      }
    } else if (isDevice !== false) {
      setIsDevice(false);
      resetDeviceFields();
    }
  }, [params.isNew, users.userDevice, users.isLoading, formik, isDevice, resetDeviceFields]);

  // Limpiar estado cuando se abre para crear nuevo usuario
  useEffect(() => {
    if (params.isNew) {
      // Resetear estados locales
      setIsDevice(null);
      setIsDeviceNew(false);
      setErrorMessage('');
      setMessageErrorImei('');
      setPasswordKey('');
      setOffice('0');
      setIsAsigned(false);
      setRol('Collector');
      setZoneManger(AccessLevels.Collector);
      setAttemptedSubmit(false);
      
      // Resetear formik
      formik.resetForm({
        values: {
          name: '',
          lastName: '',
          imei: '',
          manufacture: '',
          model: '',
          number: '',
        },
      });
      
      // Limpiar Redux
      dispatch(resetUser());
    }
  }, [params.isNew]);

  const handleSaveUser = () => {
    const branchOfficeId = office !== '0' ? office : users.branchOffices.offices[0].id;
    params.handleClose(true);
    dispatch(
      userProcess(
        {
          name: formik.values.name.trim(),
          lastName: formik.values.lastName.trim(),
          role: rol,
          branchOfficeId: branchOfficeId,
          deviceImei: formik.values.imei ? formik.values.imei : null,
        },
        params.isNew ? undefined : params.user.userName,
      ),
    );
  };

  if (params.user.zoneId !== users.filter.ZoneId && init) {
    setInit(false);
    dispatch(
      userOffices({
        ZoneId: params.user.zoneId == 0 ? null : params.user.zoneId,
      }),
    );
  }

  const handleAcepting = () => {
    if (users.error?.name || devices.error?.name) {
      params.handleClose(false, true);
    } else {
      setPasswordKey('');
      params.handleClose(false);
    }
    dispatch(resetUser());
    dispatch(resetNewDevice());
  };

  const removeDevice = () => {
    //desvincular
    resetDeviceFields();
    setIsDevice(false);
    setMessageErrorImei('');
    setErrorMessage('');
  };

  const SaveIn = () => (
    <Button
      type="submit"
      variant="contained"
      color="primary"
      className={classes.submit}
      startIcon={<Save />}
      fullWidth
    >
      Guardar
    </Button>
  );

  const aceptIn = (
    <div className={classes.flexRowCenter} style={{ gap: '12px', marginTop: '8px' }}>
      {users.error?.name || users.newUser || passwordKey != '' ? (
        <Button
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={handleAcepting}
          fullWidth
        >
          Aceptar
        </Button>
      ) : (
        <SaveIn />
      )}
    </div>
  );

  const handleResetPasswordKey = (key: string) => {
    setPasswordKey(key);
  };

  const handleResetPassword = () => {
    dispatch(resetPasswordUser(params.user.userName, handleResetPasswordKey));
  };

  const resetPasswordContent = isExistingUser
    ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'center' }}>
          {passwordKey !== '' ? (
            <Paper className={classes.paper} style={{ padding: '12px 16px', textAlign: 'center' }}>
              <Typography variant="body1" style={{ color: 'blue', fontWeight: 500 }}>
                La contraseña nueva es: {passwordKey}
              </Typography>
            </Paper>
          ) : (
            <Button
              variant="contained"
              style={{ backgroundColor: 'red', color: 'white', width: 'fit-content' }}
              onClick={handleResetPassword}
              startIcon={<VpnKey />}
            >
              Resetear Contraseña
            </Button>
          )}
        </div>
      )
    : null;

  const handleChangeNewDevice = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setIsDeviceNew(checked);
    if (!checked) {
      clearDeviceExtraFields();
      setMessageErrorImei('');
      setErrorMessage('');
    }
  };

  const handleChangeAsignedDevice = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setIsAsigned(checked);
    if (!checked) {
      setIsDevice(false);
      setIsDeviceNew(false);
      resetDeviceFields();
      setMessageErrorImei('');
      setErrorMessage('');
    }
  };

  const handleOpenRol = () => {
    setOpenRol(true);
  };

  const handleCloseRol = () => {
    setOpenRol(false);
  };

  const handleChangeRol = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newRoleId = event.target.value as string;
    const newRoleLevel = getRoleLevelFromId(newRoleId);
    setRol(newRoleId);
    setZoneManger(newRoleLevel);

    if (validateRoleRequiredDevice(newRoleId)) {
      setIsAsigned(true);
      setIsDeviceNew(false);
    } else {
      setIsAsigned(false);
      setIsDeviceNew(false);
    }

    if (newRoleLevel >= AccessLevels.RegionManager) {
      if (users.branchOffices.offices.length > 0) {
        setOffice(users.branchOffices.offices[0].id);
        changeZone({ reset: false, value: users.branchOffices.offices[0].zone.id });
      } else {
        setOffice('0');
        changeZone({ reset: true, value: 0 });
      }
    } else if (newRoleLevel === AccessLevels.ZoneManager) {
      if (theZone !== 0) {
        changeZone({ reset: false, value: theZone, flag: true });
      }
    } else {
      if (office === '0' && theZone !== 0) {
        changeZone({ reset: false, value: theZone });
      }
    }
  };

  const changeOffice = ({ value }: { reset: boolean; value: string }) => {
    setOffice(value);
    if (getRoleLevelFromId(rol) === AccessLevels.StoreManager && value !== '0') {
      const selectedOffice = users.branchOffices.offices.find((office) => office.id === value);
      if (selectedOffice) {
        changeZone({ reset: false, value: selectedOffice.zone.id, flag: true });
      }
    }
  };

  const changeZone = ({
    reset,
    value,
    flag,
  }: {
    reset: boolean;
    value: number;
    flag?: boolean;
  }) => {
    if (reset) {
      setOffice('0');
      dispatch(userOffices({ ZoneId: null }));
    } else {
      if (getRoleLevelFromId(rol) === AccessLevels.ZoneManager) {
        dispatch(
          userOffices({ ZoneId: value }, (id: string) => {
            setOffice(id);
          }, true), // matchZone = true para ZoneManager
        );
      } else {
        dispatch(userOffices({ ZoneId: value }));
      }
    }
  };

  const pagineOffice = ({ zone }: { page: number; zone: number | null }) => {
    //dispatch(workshopOffices({ size: 100, page: page }, { ZoneId: zone }));
  };

  const sectionPaperStyle: CSSProperties = {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    margin: '0',
  };

  const sectionContentStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
  };

  const renderDeviceFeedback = (): React.ReactNode => {
    if (!isAsigned) {
      return null;
    }

    if (devices.error) {
      return (
        <div className={classes.flexColumnCenter} style={{ gap: '8px', alignItems: 'center' }}>
          <Typography variant="body1">Ocurrió un error</Typography>
          {devices.error?.name === '1009' ? (
            <Typography variant="body2">Dispositivo ya está registrado</Typography>
          ) : (
            <Typography variant="body2" align="center">
              {devices.error.message}
            </Typography>
          )}
        </div>
      );
    }

    if (devices.isLoading || users.isLoading) {
      return (
        <div className={classes.flexRowCenter}>
          <CircularProgress />
        </div>
      );
    }

    if (devices.newDevice && !users.error) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <Typography variant="body1" align="center">
            Dispositivo {isDeviceNew ? 'creado' : 'asignado'} con éxito
          </Typography>
        </div>
      );
    }

    return null;
  };

  const renderUserErrorFeedback = (): React.ReactNode => {
    if (!users.error || users.error?.name === '1009') {
      return null;
    }

    return (
      <div className={classes.flexColumnCenter} style={{ gap: '8px', alignItems: 'center' }}>
        <Typography variant="body1">Ocurrió un error</Typography>
        <Typography variant="body2" align="center">
          {users.error.message}
        </Typography>
      </div>
    );
  };

  const renderUserResult = (): React.ReactNode => {
    if (users.isLoading) {
      return (
        <div className={classes.flexRowCenter}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          alignItems: 'center',
        }}
      >
        {users.newUser ? (
          <div style={{ textAlign: 'center' }}>
            <Typography variant="body1">
              Usuario {users.newUser.user.userName}
              {params.isNew ? ' creado' : ' editado'} con éxito
            </Typography>
            {params.isNew ? (
              <Typography variant="body2">
                Contraseña por defecto: {users.newUser.temporaryPassword}
              </Typography>
            ) : null}
          </div>
        ) : (
          <Typography variant="body2" color="textSecondary" align="center">
            Completa la información y guarda los cambios para ver el resultado.
          </Typography>
        )}
        {aceptIn}
      </div>
    );
  };

  const deviceFeedback = renderDeviceFeedback();
  const userErrorFeedback = renderUserErrorFeedback();
  const userResult = renderUserResult();

  return (
    <Container
      maxWidth="md"
      style={{
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        paddingBottom: '16px',
      }}
    >
      <form onSubmit={formik.handleSubmit} className={classes.form} style={{ width: '100%' }}>
        <Paper className={classes.paper} style={{ backgroundColor: '#343c89', color: 'white' }}>
          <Typography variant="h5">
            {params.isNew ? 'Crear Usuario' : `Editar Usuario: ${params.user.userName}`}
          </Typography>
        </Paper>

        <Grid container spacing={3} style={{ width: '100%', margin: 0 }}>
          <Grid item xs={12}>
            <Paper style={{ ...sectionPaperStyle, maxWidth: '720px', margin: '0 auto' }} elevation={2}>
              <Typography variant="subtitle1" color="textSecondary" style={{ fontWeight: 700 }}>
                {users.newUser ? 'Resumen del usuario' : 'Datos del usuario'}
              </Typography>
              {users.newUser ? (
                <div style={sectionContentStyle}>
                  <Typography variant="body1">
                    <strong>Nombre:</strong> {users.newUser.user.name}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Apellido:</strong> {users.newUser.user.lastName}
                  </Typography>
                  {zoneManager && zoneManager > AccessLevels.ZoneManager ? null : (
                    <Typography variant="body1">
                      <strong>{
                        zoneManager && zoneManager === AccessLevels.ZoneManager ? 'Zona' : 'Sucursal'
                      }:</strong>{' '}
                      {zoneManager && zoneManager === AccessLevels.ZoneManager
                        ? users.newUser.user.branchOffice?.zone.name
                        : users.newUser.user.branchOffice?.name}
                    </Typography>
                  )}
                  <Typography variant="body1">
                    <strong>Rol:</strong> <NameRole name={users.newUser.user.role.name} />
                  </Typography>
                  {users.newUser.user.role.accessLevel < AccessLevels.Coordinator ? (
                    <Typography variant="body1">
                      <strong>IMEI:</strong> {formik.values.imei}
                    </Typography>
                  ) : null}
                </div>
              ) : (
                <div style={sectionContentStyle}>
                  <Typography
                    variant="subtitle2"
                    color="textSecondary"
                    style={{ fontWeight: 700 }}
                  >
                    Información básica
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        onChange={handleFormikChange}
                        label="Nombre"
                        margin="normal"
                        fullWidth
                        id="name"
                        inputProps={{ maxLength: 150 }}
                        name="name"
                        autoFocus
                        value={formik.values.name}
                        error={formik.touched.name && Boolean(formik.errors.name)}
                        helperText={formik.touched.name && formik.errors.name}
                        variant="outlined"
                        InputLabelProps={{ style: { fontWeight: 600 } }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        onChange={handleFormikChange}
                        label="Apellido"
                        margin="normal"
                        inputProps={{ maxLength: 150 }}
                        fullWidth
                        id="lastName"
                        name="lastName"
                        value={formik.values.lastName}
                        error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                        helperText={formik.touched.lastName && formik.errors.lastName}
                        variant="outlined"
                        InputLabelProps={{ style: { fontWeight: 600 } }}
                      />
                    </Grid>
                  </Grid>

                  {zoneManager && zoneManager > AccessLevels.ZoneManager ? null : (
                    <>
                      {attemptedSubmit && String(office) === '0' && getRoleLevelFromId(rol) < AccessLevels.ZoneManager ? (
                        <Paper 
                          style={{ 
                            padding: '12px 16px', 
                            backgroundColor: '#fff3e0', 
                            border: '1px solid #ff9800',
                            borderRadius: '4px',
                            marginBottom: '12px'
                          }}
                        >
                          <Typography 
                            variant="body2" 
                            align="center" 
                            style={{ 
                              color: '#e65100', 
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                            }}
                          >
                            ⚠️ Debe asignar una sucursal
                          </Typography>
                        </Paper>
                      ) : null}
                      <FilterZoneOffice
                        changeZone={changeZone}
                        changeOffice={changeOffice}
                        complexUser={getRoleLevelFromId(rol) === AccessLevels.ZoneManager ? 4 : 1}
                        filter={{
                          zone: theZone,
                          office: office,
                        }}
                        offices={users.branchOffices}
                        pagineOffice={pagineOffice}
                      />
                    </>
                  )}

                  {getRoleLevelFromId(rol) < myRole ? (
                    <FormControl style={{ margin: '10px 0' }} className={classes.formControl} fullWidth>
                      <InputLabel id="select-filter-rol" style={{ fontWeight: 600 }}>
                        Rol
                      </InputLabel>
                      <Select
                        labelId="select-filter-rol"
                        id="filter-controlled-open-select-rol"
                        open={openRol}
                        onClose={handleCloseRol}
                        onOpen={handleOpenRol}
                        value={rol}
                        onChange={handleChangeRol}
                      >
                        {RolesList.map((item) => {
                          if (
                            (item.level < myRole ||
                              (myRole == AccessLevels.Admin && item.id == 'FinanceManager')) &&
                            !(
                              myRole == AccessLevels.HelpDesk &&
                              item.level == AccessLevels.CommercialManager
                            )
                          ) {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          }
                          return null;
                        })}
                      </Select>
                    </FormControl>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No puedes cambiar el rol de este usuario.
                    </Typography>
                  )}
                </div>
              )}
            </Paper>
          </Grid>

          <Grid item xs={12} md={resetPasswordContent ? 6 : 12}>
            <Paper style={sectionPaperStyle} elevation={2}>
              <Typography variant="subtitle1" color="textSecondary" style={{ fontWeight: 700 }}>
                Gestión de dispositivo
              </Typography>
              {rol != 'FinanceManager' && getRoleLevelFromId(rol) < AccessLevels.Coordinator  ? (
                <div style={sectionContentStyle}>
                  {isDevice ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'center' }}>
                      <Paper className={classes.paper} style={{ textAlign: 'center' }}>
                        <Typography variant="body1">IMEI asignado: {formik.values.imei}</Typography>
                      </Paper>
                      <Button
                        variant="contained"
                        style={{ backgroundColor: 'red', color: 'white' }}
                        className={classes.submit}
                        onClick={removeDevice}
                        startIcon={<LinkOff />}
                      >
                        Desvincular
                      </Button>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', alignItems: isAsigned ? 'stretch' : 'center' }}>
                      <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChangeAsignedDevice}
                              name="checkbox-newdevice"
                              checked={isAsigned}
                              color="primary"
                            />
                          }
                          label={<span style={{ fontWeight: 600 }}>Agregar dispositivo</span>}
                        />
                        {isAsigned && myRole !== AccessLevels.CommercialManager ? (
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={handleChangeNewDevice}
                                checked={isDeviceNew}
                                name="checkbox-newdevice"
                                color="primary"
                              />
                            }
                            label={<span style={{ fontWeight: 600 }}>Nuevo dispositivo</span>}
                          />
                        ) : null}
                      </div>
                      {messageErrorImei && attemptedSubmit ? (
                        <Typography color="error" variant="body2" style={{ fontWeight: 600 }}>
                          ⚠️ {messageErrorImei}
                        </Typography>
                      ) : null}
                      {isAsigned ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                          <TextField
                            onChange={handleFormikChange}
                            label="Dispositivo (IMEI)"
                            margin="normal"
                            inputProps={{ maxLength: 16 }}
                            id="imei"
                            name="imei"
                            fullWidth
                            value={formik.values.imei}
                            error={formik.touched.imei && Boolean(formik.errors.imei)}
                            helperText={formik.touched.imei && formik.errors.imei}
                            variant="outlined"
                            InputLabelProps={{ style: { fontWeight: 600 } }}
                          />
                          {errorMessage ? (
                            <Typography color="error" variant="body2">
                              {errorMessage}
                            </Typography>
                          ) : null}
                          {isDeviceNew ? (
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <TextField
                                  onChange={handleFormikChange}
                                  label="Marca"
                                  margin="normal"
                                  id="manufacture"
                                  inputProps={{ maxLength: 35 }}
                                  name="manufacture"
                                  fullWidth
                                  value={formik.values.manufacture}
                                  error={
                                    formik.touched.manufacture &&
                                    Boolean(formik.errors.manufacture)
                                  }
                                  helperText={
                                    formik.touched.manufacture && formik.errors.manufacture
                                  }
                                  variant="outlined"
                                  InputLabelProps={{ style: { fontWeight: 600 } }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField
                                  onChange={handleFormikChange}
                                  label="Modelo"
                                  margin="normal"
                                  id="model"
                                  name="model"
                                  inputProps={{ maxLength: 150 }}
                                  fullWidth
                                  value={formik.values.model}
                                  error={
                                    formik.touched.model && Boolean(formik.errors.model)
                                  }
                                  helperText={formik.touched.model && formik.errors.model}
                                  variant="outlined"
                                  InputLabelProps={{ style: { fontWeight: 600 } }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField
                                  onChange={handleFormikChange}
                                  label="Número"
                                  margin="normal"
                                  id="number"
                                  name="number"
                                  inputProps={{ maxLength: 8 }}
                                  fullWidth
                                  value={formik.values.number}
                                  error={
                                    formik.touched.number && Boolean(formik.errors.number)
                                  }
                                  helperText={
                                    formik.touched.number && formik.errors.number
                                  }
                                  variant="outlined"
                                  InputLabelProps={{ style: { fontWeight: 600 } }}
                                />
                              </Grid>
                            </Grid>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  Este rol no requiere un dispositivo asignado.
                </Typography>
              )}
            </Paper>
          </Grid>

          {resetPasswordContent ? (
            <Grid item xs={12} md={6}>
              <Paper style={sectionPaperStyle} elevation={2}>
                <Typography variant="subtitle1" color="textSecondary" style={{ fontWeight: 700 }}>
                  Recuperación de contraseña
                </Typography>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px', minHeight:'102px' }}>
                  {resetPasswordContent}
                </div>
              </Paper>
            </Grid>
          ) : null}

          {deviceFeedback ? (
            <Grid item xs={12}>
              <Paper style={sectionPaperStyle} elevation={1}>
                <Typography variant="subtitle1" color="textSecondary" style={{ fontWeight: 700 }}>
                  Estado del dispositivo
                </Typography>
                {deviceFeedback}
              </Paper>
            </Grid>
          ) : null}

          {userErrorFeedback ? (
            <Grid item xs={12}>
              <Paper style={sectionPaperStyle} elevation={1}>
                {userErrorFeedback}
              </Paper>
            </Grid>
          ) : null}

          <Grid item xs={12}>
            <Paper style={sectionPaperStyle} elevation={1}>
              {userResult}
            </Paper>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
